import styled, { keyframes } from "styled-components";

import { Link } from "react-router-dom";
import { FaSearch, FaTimes } from "react-icons/fa";

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;

  display: flex;
  /* align-items: center; */
  justify-content: center;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const Content = styled.div`
  width: 80%;
  height: fit-content;
  margin: 40px 10px;
  z-index: 1;

  padding: 30px;
  border-radius: 10px;

  overflow: hidden;

  animation: ${fadeIn} 0.4s;

  > h1 {
    margin-bottom: 10px;
  }

  @media (max-width: 425px) {
    width: 95%;
    padding: 0;
  }

  @media (max-width: 768px) {
    width: 95%;
    padding: 0;
  }
`;

export const Card = styled.section`
  padding: 10px;
  margin-bottom: 30px;

  border-radius: 10px;

  > h1 {
    font-size: 25px;
    margin-bottom: 10px;
  }

  transition: opacity 0.2s;
`;

export const LinkMenu = styled(Link)`
  color: var(--black);
  width: 100px;

  text-decoration: none;
  font-weight: bold;

  :hover {
    opacity: 0.8;
  }
  :active {
    opacity: 0.6;
  }
`;

export const StyledVaga = styled.article`
  padding: 10px 20px;
  margin-bottom: 10px;
  max-height: 500px;
  max-height: 100px;

  border-radius: 10px;
  background-color: var(--white);
  box-shadow: 2px 2px 5px black;
  color: var(--white);

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  cursor: context-menu;

  position: relative;

  :hover {
    max-height: 200px;
    overflow: hidden;
  }

  transition: max-height 0.2s ease-out;

  @media (max-width: 425px) {
    flex-direction: column;
    padding: 10px;
    align-items: flex-start;
    gap: 20px;
    max-height: 150px;

    :hover {
      max-height: 250px;
      overflow: hidden;
    }

    > span {
      align-self: center;
    }
  }

  > section {
    color: var(--black);

    display: flex;
    flex-direction: column;
    gap: 3px;

    > h3 {
      color: var(--black);
      margin: 0px 4px 0px 0px;

      > span {
        color: var(--black);
        margin-bottom: 4px;
        font-weight: normal;

        font-size: 14px;
      }
    }

    > h4 {
      font-weight: normal;
    }

    > p {
      color: var(--black);
      margin-bottom: 4px;

      font-size: 14px;

      > span {
        color: var(--green);
        font-weight: bold;
        font-size: 18px;
      }
    }
  }

  > span {
    color: var(--black);
    height: 100%;
    font-size: 20px;

    display: flex;
    align-items: center;

    > p {
      cursor: pointer;
      :hover {
        opacity: 0.7;
      }

      :active {
        opacity: 0.4;
      }
    }
  }
`;

export const IconSearch = styled(FaSearch)`
  font-size: 30px;
  position: absolute;

  transition: opacity 0.3s;
`;
export const IconTimes = styled(FaTimes)`
  font-size: 30px;
  position: absolute;

  cursor: pointer;
`;

export const ContainerFilter = styled.form`
  margin: 10px;
  font-size: 25px;

  background-color: var(--white);
  padding: 5px;
  padding-left: 10px;
  border-radius: 10px;

  display: flex;
  align-items: center;
  gap: 10px;
  cursor: text;

  color: var(--gray);

  box-shadow: 2px 2px 5px black;

  > input {
    width: 100%;
    padding-left: 40px;
    border: none;

    transition: 0.2s;
  }

  > button {
    margin: 0;
  }
`;
